exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#profile-data {\n  max-width: 1072px;\n  width: 100%;\n}\n\n.profile-card {\n  max-width: 1060px;\n  width: 100%;\n}", ""]);

// exports
